module.exports = __webpack_public_path__ + "static/media/LokiFrame85.39a26636.png";